module.exports = __webpack_public_path__ + "static/media/md-restaurant.504a2e8a.svg";